module.exports = __webpack_public_path__ + "img/gls_gbt5780_2000.prt.161ebbee.jpg";